





























































  /* eslint-disable no-console */

import {LoginRequestDTO} from "@/dtos/sqe-dtos";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Login extends Vue {
  username = ''
  password = ''
  loginFail = false

  async mounted() {
    const jwt = window.localStorage.getItem('jwt')
    await this.validateJwt(jwt)
  }

  async login() {
    if (!this.username || !this.password) {
      this.loginFail = true
    } else {
      try {
        const login: LoginRequestDTO = {
          email: this.username,
          password: this.password
        }
        const cred = await this.$com.sqeComms?.postV1UsersLogin(login)
        await this.validateJwt(cred?.token)
      } catch (err) {
        console.error(err)
        this.loginFail = true
      }
    }
  }

  async validateJwt(jwt: string | undefined | null) {
    if (jwt){
      window.localStorage.setItem('jwt', jwt)
      const loggedIn = await this.$com.setJwt(jwt)
      const user = await this.$com.sqeComms?.getV1Users()
      if (loggedIn && user !== undefined) {
        this.loginFail = false
        this.$store.commit('session_idSet', jwt)
        this.$store.commit('user_nameSet', user.email)
        this.$router.push('app')
      }
    }
  }
}
